export default __webpack_public_path__ + "b7307b30bf884ec2aa8a866549f1b57f.svg";